<nz-layout class="questionnaire-history-table">
  @if (error && !isLoading) {
    <div class="history-state history-error">
      {{ error }}
    </div>
  }

  @if (!error) {
    <ng-container>
      <div fxLayout="row" fxLayoutGap="20px">
        @if (!isChartVisible) {
          <div fxFlex="auto">
            <app-reusable-table
              [title]="getQuestionnaireTitle()"
              [columns]="getColumns()"
              [rowFields]="getRowFields()"
              [data]="tableRows"
              [isLoading]="isLoading"
              [pagination]="true"
              [isPreview]="false"
              [customEmptyText]="'No questionnaire history found.'"
              [customActions]="customActions"
              [showAddButtonOverride]="showAddButton"
              [showAddButtonDisabledOverride]="addButtonDisabled"
              [addButtonDisabledTooltip]="addButtonDisabledReason"
              [addButtonHandler]="onAddQuestionnaire.bind(this)"
              [addPermissions]="getAddPermissions()"
            />
          </div>
        }

        @if (isChartVisible) {
          <div fxFlex="auto">
            <app-questionnaire-history-chart
              class="w-100"
              [data]="historyItems"
              [questionnaireTemplateId]="questionnaireTemplateId"
              [title]="getQuestionnaireTitle()"
            />
          </div>
        }

        @if (canShowGraph()) {
          <div fxFlex="auto">
            <button nz-button (click)="toggleChartView()">
              <i nz-icon nzType="icons:chart" [visible]="!isChartVisible"></i>
              <i nz-icon nzType="icons:table" [visible]="isChartVisible"></i>
            </button>
          </div>
        }
      </div>
    </ng-container>
  }
</nz-layout>
